import { render, staticRenderFns } from "./Despacho.vue?vue&type=template&id=319deef3&"
import script from "./Despacho.vue?vue&type=script&lang=ts&"
export * from "./Despacho.vue?vue&type=script&lang=ts&"
import style0 from "./Despacho.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('319deef3', component.options)
    } else {
      api.reload('319deef3', component.options)
    }
    module.hot.accept("./Despacho.vue?vue&type=template&id=319deef3&", function () {
      api.rerender('319deef3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Despacho/Despacho.vue"
export default component.exports